import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import LoadingBar from 'react-redux-loading-bar';

const bem = new BEMHelper('LoadingBar');

const propTypes = {
    className: PropTypes.string,
};

const ReduxLoadingBar = (props) => {
    const { className } = props;
    return (
        <div className={bem()}>
            <LoadingBar className={bem('bar', null, className)} showFastActions />
        </div>
    );
};

ReduxLoadingBar.propTypes = propTypes;

export default ReduxLoadingBar;
